/**
 * @flow
 * @relayHash 1b1009ecdff12fd4dd30b08400e85865
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type TutorsAdminQueryResponse = {|
  +admin: ?{| |};
|};
*/


/*
query TutorsAdminQuery(
  $count: Int!
  $cursor: String
  $email: String
  $hasStartedJobs: Boolean
  $hasOpenJobOffers: Boolean
  $hasDocuments: Boolean
  $status: [UserStatus]
  $name: String
) {
  admin {
    ...Tutors_admin_1G22uz
  }
}

fragment Tutors_admin_1G22uz on Admin {
  allTutors(first: $count, after: $cursor, email: $email, hasStartedJobs: $hasStartedJobs, hasOpenJobOffers: $hasOpenJobOffers, hasDocuments: $hasDocuments, status: $status, name: $name) {
    edges {
      node {
        __typename
        id
        firstname
        lastname
        createdAt
        openJobOffersCount
        startedJobsCount
        cellphoneNumber
        user {
          email
          status
          id
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "count",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "cursor",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "email",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasStartedJobs",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasOpenJobOffers",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasDocuments",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "status",
        "type": "[UserStatus]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "name",
        "type": "String",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TutorsAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Tutors_admin",
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor",
                "type": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "TutorsAdminQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "count",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "cursor",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "email",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasStartedJobs",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasOpenJobOffers",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasDocuments",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "status",
        "type": "[UserStatus]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "name",
        "type": "String",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "TutorsAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "cursor",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "email",
                "variableName": "email",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "count",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "hasDocuments",
                "variableName": "hasDocuments",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "hasOpenJobOffers",
                "variableName": "hasOpenJobOffers",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "hasStartedJobs",
                "variableName": "hasStartedJobs",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "name",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "status",
                "variableName": "status",
                "type": "[UserStatus]"
              }
            ],
            "concreteType": "TutorConnection",
            "name": "allTutors",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "TutorEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Tutor",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "firstname",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "lastname",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "openJobOffersCount",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "startedJobsCount",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "cellphoneNumber",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "email",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "cursor",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "email",
                "variableName": "email",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "count",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "hasDocuments",
                "variableName": "hasDocuments",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "hasOpenJobOffers",
                "variableName": "hasOpenJobOffers",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "hasStartedJobs",
                "variableName": "hasStartedJobs",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "name",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "status",
                "variableName": "status",
                "type": "[UserStatus]"
              }
            ],
            "handle": "connection",
            "name": "allTutors",
            "key": "Tutors_allTutors",
            "filters": [
              "email",
              "hasStartedJobs",
              "hasOpenJobOffers",
              "hasDocuments",
              "status",
              "name"
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query TutorsAdminQuery(\n  $count: Int!\n  $cursor: String\n  $email: String\n  $hasStartedJobs: Boolean\n  $hasOpenJobOffers: Boolean\n  $hasDocuments: Boolean\n  $status: [UserStatus]\n  $name: String\n) {\n  admin {\n    ...Tutors_admin_1G22uz\n  }\n}\n\nfragment Tutors_admin_1G22uz on Admin {\n  allTutors(first: $count, after: $cursor, email: $email, hasStartedJobs: $hasStartedJobs, hasOpenJobOffers: $hasOpenJobOffers, hasDocuments: $hasDocuments, status: $status, name: $name) {\n    edges {\n      node {\n        __typename\n        id\n        firstname\n        lastname\n        createdAt\n        openJobOffersCount\n        startedJobsCount\n        cellphoneNumber\n        user {\n          email\n          status\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/__generated__/TutorsAdminQuery.graphql.js